module.exports = __webpack_public_path__ + "img/merchant.60eb0aa4.svg";